module.exports = __webpack_public_path__ + "img/80000001.2d286442.png";